import { useState } from "react";
import { useLocation } from "react-router-dom-v5-compat";

import { Box, Button, Heading } from "@seneca/senekit";

import SignUpFormBottomLink from "features/sign-up/components/SignUpFormBottomLink";
import SignUpFormButtons from "features/sign-up/components/SignUpFormButtons";

import { SignInCardAppsContainerProps } from "../../containers/SignInCardContainer";
import SignInCardFlowsContainer from "../../containers/SignInCardFlowsContainer";
import { RenderSignInFormProps } from "../../SignInCardCommon";
import SignInOptionsCard from "./components/SignInOptionsCard";
import SignInWithOptionalPasswordCard from "./components/SignInWithOptionalPasswordCard";

export default function SignInCardStandard(
  props: SignInCardAppsContainerProps
) {
  const location = useLocation();
  const [showSignInWithEmailForm, setShowSignInWithEmailForm] = useState(
    location.state?.showSignInWithEmailForm ?? false
  );

  const renderForm = (renderProps: RenderSignInFormProps) => (
    <Box
      dataTest="SignUpFormWrapper"
      paddingTop={["xlarge", "none"]}
      height="100%"
    >
      {showSignInWithEmailForm ? (
        <SignInWithOptionalPasswordCard
          {...renderProps}
          linkToPasswordReset={props.linkToPasswordReset}
          onClickLoginAnotherWay={() => setShowSignInWithEmailForm(false)}
        />
      ) : (
        <SignInOptionsCard {...renderProps}>
          {{
            header: (
              <Heading level="3" align="center">
                {renderProps.headerMessage ?? "Welcome back!"}
              </Heading>
            ),
            ssoButtons: (
              <SignUpFormButtons
                setErrorMessage={renderProps.setErrorMessage}
                onSignInSuccess={renderProps.onSignInSuccess}
                redirectAuthenticatedUserTo={props.redirectAuthenticatedUserTo}
              />
            ),
            bottomLink: (
              <SignUpFormBottomLink
                bottomText="New to Seneca?"
                bottomLink={{ ...location, pathname: props.linkToSignUp }}
                bottomLinkText="Sign up"
              />
            ),
            emailButton: (
              <Button
                type="button"
                width="100%"
                onClick={() => setShowSignInWithEmailForm(true)}
              >
                Continue with email
              </Button>
            )
          }}
        </SignInOptionsCard>
      )}
    </Box>
  );

  return (
    <SignInCardFlowsContainer {...props}>{renderForm}</SignInCardFlowsContainer>
  );
}
